export default "__VITE_ASSET__Cq3y7gvK__"